import Column from 'components/Column'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 79px;
  background: white;
  padding: 7.5px 8px;
  gap: 4px;
`

export const Img = styled.img`
  border-radius: 100px;
  background: black;
  padding: 11px;
  height: 64px;
  width: 64px;
`

export const Copy = styled(Column)`
  margin-left: 5px;
  flex: 1;
  justify-content: space-around;

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    color: #090b0a;
    margin: 0;
  }

  small {
    font-weight: 400;
    font-size: 11px;
    line-height: 12px;
    color: #848489;
    margin: 0;
  }

  caption {
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    color: #848489;
    margin: 0;
    text-align: left;
  }
`
